import { gWhiteLabel } from "../whitelabel/brand";
import { enumBrand } from "../constants";

function ResolveFontFamily(fontName) {
  if (!fontName || fontName.indexOf(",") !== -1) return fontName;
  var brandFont = gWhiteLabel === enumBrand.isolved ? "Roboto" : "Aeonik";
  return `${fontName}, ${brandFont}`;
}

export function BuildFontString(fontName, fontSize, bold, italic) {
  var fontString = "";
  if (bold) fontString = "bold";

  var s;
  if (italic) {
    if (fontString.length > 0) s = " ";
    else s = "";
    fontString = fontString.concat(s, "italic");
  }

  if (fontString.length > 0) s = " ";
  else s = "";
  fontString = fontString.concat(s, fontSize, "px", " ", ResolveFontFamily(fontName));

  return fontString;
}
